import { CommentCategoryResource, CommentCategoryViewModel } from '../../models'

export default function transformCommentCategory(resource: CommentCategoryResource): CommentCategoryViewModel {
    return {
        id: resource.id,
        name: resource.name,
        slug: resource.slug,
    }
}
